const sessionModes = {
    WORK: 'WORK',
    SHORT_BREAK: 'SHORT_BREAK',
    LONG_BREAK: 'LONG_BREAK'
};

export default sessionModes;


// WEBPACK FOOTER //
// ./src/constants/SessionModes.js